<template>
    <div class="email-component">
        <b-input 
            :placeholder="placeholder"
            type="email"
            :required="required"
            v-bind:value="value"
            v-on:input="$emit('input', $event)">
        </b-input>
    </div>
</template>

<script>

export default {
    name: 'Email',
    components: {
    },
    props: {
        component: Object,
        value: String,
        required: Boolean,
    },
    data: function () {
        return {
        }
    },
    methods: {

    },
    mounted(){

    },     
    computed: {
        placeholder () {
            return this.component.placeholder ?? null
        },
    }
}

</script>

<style>

</style>

